
import Hero from './components/Hero';
import About from './components/About';
import VenuesList from './components/VenuesList';
import Activities from './components/Activities';
import Artists from './components/Artists';
import Schedule from './components/Schedule';
import Contact from './components/Contact';
import LiveCalendar from './components/LiveCalendar';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <VenuesList />
      <Activities />
      <Artists />
      <Schedule />
      <Contact />
      <LiveCalendar />
      <Footer />
    </div>
  );
}
